import { render, staticRenderFns } from "./LocationsListAddNew.vue?vue&type=template&id=5822b3b4&"
import script from "./LocationsListAddNew.vue?vue&type=script&lang=js&"
export * from "./LocationsListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./LocationsListAddNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports